import React, { Fragment } from 'react';
import Image from '../../assets/Services/process.svg';
import Arrow from './arrow.png';
import './Process.css';
import Fade from 'react-reveal/Fade';
import { Dimensions } from "../../Helper/sitedimension";

const process = () => {
    const { width } = Dimensions.useWindowDimensions();
    return (
        <div className="process">
            {width > 500 ?
                <div className="container-fluid bg-1">
                    <Fade delay={1200}>
                        <img className="process-image" src={Image} alt="process" />
                    </Fade>
                    <div className="main">
                        <Fade delay={300}>
                            <span className="content"> Our  </span>
                            <span className="content1"> Process </span>
                        </Fade>
                    </div>
                    <div className="points">
                        <div className="processpoint1">
                            <Fade delay={400}>
                                <img className="arrow" src={Arrow} alt="arrow" />
                                <span className="content">Assess your digital stack and get figure out the scope of cyber attacks.</span>
                            </Fade>
                        </div>
                        <div className="processpoint2">
                            <Fade delay={500}>
                                <img className="arrow" src={Arrow} alt="arrow" />
                                <span className="content">Deeply analyse the current risks in your business. </span>
                            </Fade>
                        </div>
                        <div className="processpoint3">
                            <Fade delay={600}>
                                <img className="arrow" src={Arrow} alt="arrow" />
                                <span className="content">Actionable insights to find out the gaps in your system.</span>
                            </Fade>
                        </div>
                        <div className="processpoint4">
                            <Fade delay={700}>
                                <img className="arrow" src={Arrow} alt="arrow" />
                                <span className="content">Get detailed reports and scoring of your Web Apps based on its protection level.</span>
                            </Fade>
                        </div>
                        <div className="processpoint5">
                            <Fade delay={800}>
                                <img className="arrow" src={Arrow} alt="arrow" />
                                <span className="content">Our ML Model Predict the possibility of future attacks and take measures immediately.</span>
                            </Fade>
                        </div>
                    </div>
                </div> :
                <Fragment>
                    <Fade delay={300}>
                        <img className="process-imagepro" src={Image} alt="process" />
                    </Fade>
                    <div className="mainpro">
                        <Fade delay={300}>
                            <span className="contentpro"> Our  </span>
                            <span className="content1pro"> Process </span>
                        </Fade>
                    </div>
                    <div className="pointspro">
                        <div className="processpoint1pro">
                            <Fade delay={400}>
                                <img className="arrowpro" src={Arrow} alt="arrow" />
                                <span className="content">Assess your digital stack and get figure out the scope of cyber attacks.</span>
                            </Fade>
                        </div>
                        <div className="processpoint2pro">
                            <Fade delay={500}>
                                <img className="arrowpro" src={Arrow} alt="arrow" />
                                <span className="content">Deeply analyse the current risks in your business. </span>
                            </Fade>
                        </div>
                        <div className="processpoint3pro">
                            <Fade delay={600}>
                                <img className="arrowpro" src={Arrow} alt="arrow" />
                                <span className="content">Actionable insights to find out the gaps in your system.</span>
                            </Fade>
                        </div>
                        <div className="processpoint4pro">
                            <Fade delay={700}>
                                <img className="arrowpro" src={Arrow} alt="arrow" />
                                <span className="content">Get detailed reports and scoring of your Web Apps based on its protection level.</span>
                            </Fade>
                        </div>
                        <div className="processpoint5pro">
                            <Fade delay={800}>
                                <img className="arrowpro" src={Arrow} alt="arrow" />
                                <span className="content">Our ML Model Predict the possibility of future attacks and take measures immediately.</span>
                            </Fade>
                        </div>
                    </div>
                </Fragment>
            }
        </div >
    )
}

export default process;